import React, { useCallback } from 'react';
import { throttle } from 'underscore';
import { useResizeObserver } from '@core/js/hooks/useResizeObserver';

export const useUpdateTableHeight = (
    tableItemsLength: number,
    tableItemRef: React.RefObject<HTMLDivElement>,
    tableHeight: React.Dispatch<React.SetStateAction<number>> | ((val: number) => void), /* Lugano changes */
    itemHeight?: React.Dispatch<React.SetStateAction<number>> /* Lugano changes */
) => {
    const updateTableHeight = useCallback((): void => {
        const tableItem = tableItemRef.current;

        if (!tableItem) {
            return;
        }

        const { height } = tableItem.getBoundingClientRect();
        /* Lugano changes */
        const computedStyle = window.getComputedStyle(tableItemRef.current);
        const marginTop = parseFloat(computedStyle.marginTop);
        const marginBottom = parseFloat(computedStyle.marginBottom);

        const heightWithMargins = height + marginTop + marginBottom;

        if (itemHeight) {
            itemHeight(heightWithMargins);
        }

        tableHeight(tableItemsLength * heightWithMargins); /* Lugano changes (removed +1px) */
        /* Lugano changes */
    }, [tableItemsLength, tableHeight, tableItemRef, itemHeight]);

    return useResizeObserver({
        // eslint-disable-next-line react-hooks/exhaustive-deps
        callback: useCallback(throttle(updateTableHeight, 500), [updateTableHeight])
    });
};
